import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const CustomPopper = styled(Box)`
  .ineffective-property {
    font-size: 0; /* This property has no visible effect, only to fix lint */
  }
`;
